import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { faPrint } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { downloadFile } from "src/utils/fileDownloading.ts";
import { DeliveryView } from "src/api/generated/erp/db/types/tables/deliveryView.ts";
import { DeliveryPrintoutApi } from "src/api/generated/erp/delivery/api/deliveryPrintoutApi.ts";

export interface PrintDeliveryButtonProps extends AsyncButtonProps {
	delivery: DeliveryView | undefined;
	/** Prints through the cargo driver API, which accepts only deliveries of the driver's own transports. */
	cargoDriverView?: boolean;
}

export const PrintDeliveryConsignmentNoteButton = ({
	delivery,
	cargoDriverView = false,
	...other
}: PrintDeliveryButtonProps) => {
	return (
		<AsyncButton
			icon={faPrint}
			label={i18n.t("consignment_note")}
			variant={"outlined"}
			disabled={delivery == null}
			onClick={async () => {
				if (delivery == null) return;
				const fileHandle =
					cargoDriverView ?
						await DeliveryPrintoutApi.printDeliveryConsignmentNoteForCargoDriver({ deliveryId: delivery.deliveryId })
					:	await DeliveryPrintoutApi.printDeliveryConsignmentNote({ deliveryId: delivery.deliveryId });
				downloadFile(fileHandle);
			}}
			{...other}
		/>
	);
};

export const PrintDeliveryPackingSlipButton = ({
	delivery,
	cargoDriverView = false,
	...other
}: PrintDeliveryButtonProps) => {
	return (
		<AsyncButton
			icon={faPrint}
			label={i18n.t("packing_slip")}
			variant={"outlined"}
			disabled={delivery == null}
			onClick={async () => {
				if (delivery == null) return;
				const fileHandle =
					cargoDriverView ?
						await DeliveryPrintoutApi.printDeliveryPackingSlipForCargoDriver({ deliveryId: delivery.deliveryId })
					:	await DeliveryPrintoutApi.printDeliveryPackingSlip({ deliveryId: delivery.deliveryId });
				downloadFile(fileHandle);
			}}
			{...other}
		/>
	);
};

export const PrintDeliveryNoteButton = ({
	delivery,
	cargoDriverView = false,
	...other
}: PrintDeliveryButtonProps) => {
	return (
		<AsyncButton
			icon={faPrint}
			label={i18n.t("delivery_note")}
			variant={"outlined"}
			disabled={
				delivery == null ? true : delivery.deliveryState !== "DELIVERED" ? i18n.t("delivery_note_print_requires_delivered") : false
			}
			onClick={async () => {
				if (delivery == null || delivery.deliveryState !== "DELIVERED") return;
				const fileHandle =
					cargoDriverView ?
						await DeliveryPrintoutApi.printDeliveryNoteForCargoDriver({ deliveryId: delivery.deliveryId })
					:	await DeliveryPrintoutApi.printDeliveryNote({ deliveryId: delivery.deliveryId });
				downloadFile(fileHandle);
			}}
			{...other}
		/>
	);
};
